const STORY_CONTAINER_CLASS_NAME = 'js-story-container';
const IFRAME_CLASS_NAME = 'story__frame';

// Create and deploy iframe every time to avoid unnecessary histories
const createIframe = () => {
  const iframe = document.createElement('iframe');
  iframe.sandbox = 'allow-scripts allow-same-origin allow-popups';
  iframe.title = 'ストーリー表示用枠';
  iframe.classList.add(IFRAME_CLASS_NAME);
  return iframe;
}

const showIframe = src => {
  const iframe = createIframe();
  const storyFrame = document.querySelector(`.${STORY_CONTAINER_CLASS_NAME}`);
  storyFrame.appendChild(iframe);
  iframe.setAttribute('src', src);
  storyFrame.classList.add('active');
  storyFrame.setAttribute('aria-hidden', 'false');
}

const clearIframe = () => {
  const iframe = document.querySelector(`.${IFRAME_CLASS_NAME}`);
  const storyFrame = document.querySelector(`.${STORY_CONTAINER_CLASS_NAME}`);
  storyFrame.classList.remove('active');
  storyFrame.setAttribute('aria-hidden', 'true');
  storyFrame.removeChild(iframe);
}

const handleStoryLinkClick = event => {
  const anchorEl = event.target.parentNode;
  const { amebaId } = anchorEl.dataset;
  // Use anchor link if amebaId is not provided (rare case)
  if (!amebaId) {
    return true;
  }

  event.preventDefault();
  showIframe(`https://content.ameba.jp/blogoftheyear/2019/stories/${amebaId}.html`);
  history.pushState({}, '', `/blogoftheyear/2019/stories/${amebaId}.html`);
  document.body.classList.add('freeze');
}

const handleStoryCloseButtonClick = () => {
  clearIframe();
  document.body.classList.remove('freeze');
  history.pushState({}, '', `/blogoftheyear/2019/`);
};

const handleReceiveMessage = event => {
  if (event.origin.endsWith('.ameba.jp') &&  event.data.type === 'CLOSE') {
    handleStoryCloseButtonClick();
  }
}

const storyLinks = document.querySelectorAll('.js-story-link');
[].forEach.call(storyLinks, link => link.addEventListener('click', handleStoryLinkClick, false));
window.addEventListener("message", handleReceiveMessage, false);
window.addEventListener('popstate', () => {
  if (!location.pathname.includes('stories/')) {
    handleStoryCloseButtonClick();
  }
}, false);
